export default "__VITE_ASSET__CNrerT3y__"